// ---------------------------------------------------------------------------
// GA4 events for Lenny's entry points and funnel (growth plan, 2026-09-30).
// foodfacts.org loads GA4 through Webflow's integration, which defines
// window.gtag; Consent Pro decides what GA4 may store. Where gtag is missing
// (another host page, or a blocker) events are simply dropped.
//
//   lenny_open       the chat panel opened        { entry }
//   lenny_question   a question was sent          { entry, first: 'yes' | 'no' }
//   lenny_voice      a voice call was started     { entry }
//   lenny_link_click a link in a reply was tapped { entry, link_type }
//   lenny_whatsapp   the WhatsApp option was used { entry }
//
// `entry` names where the visitor started: launcher, home_bubble, home_float,
// or whatever the host page passes to FoodFactsVoiceWidget.ask()/open().
// ---------------------------------------------------------------------------
export function track(name, params) {
  try {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  } catch (e) {
    // Analytics must never break the widget.
  }
}
